import React from 'react';
import { ReactComponent as IconFacebook } from './assets/icons/facebook.svg';
import { ReactComponent as IconTwitter } from './assets/icons/twitter.svg';
import { ReactComponent as IconGithub } from './assets/icons/github.svg';
import "./App.css";

class App extends React.Component {
  render = () => {
    return (
      <div className="card">
        <div className="header">
          <div className="logo">
            <a href=".">BRAIN</a>
          </div>
          <div className="social">
            {/* <a href="https://facebook.com/etnikbeqiri.365" title="Facebook" target="_blank" rel="noopener noreferrer">
              <IconInstagram className="icon" />
            </a> */}
            <a href="https://twitter.com/etnikbeqiri" title="Twitter" target="_blank" rel="noopener noreferrer">
              <IconTwitter className="icon" />
            </a>
            <a href="https://github.com/etnikbeqiri1" title="GitHub" target="_blank" rel="noopener noreferrer">
              <IconGithub className="icon" />
            </a>
          </div>
        </div>
        <div className="content">
          <div className="title-holder">
            <h1>Get ready for the change.</h1>
            <p>Website coming soon. Please check back to know more. Shoot us an email if you're curious.</p>
          </div>
          <a href="mailto:etnik@brain.al">
            <div className="cta">Send us an email</div>
          </a>
        </div>
        <div className="footer">
          <span>Back with you soon!</span>
        </div>
      </div>
    );
  }
}

export default App;